module.exports = __webpack_public_path__ + "resources/img/img_dsm1_m.485c137abcf40c958aa16ca2f285a0f7.png";